import ImagesUploader from "./images-uploader";
export default ImagesUploader;